// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__6CEJE","col":"CardReaderDesc_col__1W4QI","label":"CardReaderDesc_label__3Cfxw"};